import React from 'react';

import { Typography } from 'antd';
import styled from 'styled-components';

import { useAppSelector } from 'store/hook';
import { CompanyType } from 'types/company';

import { useShopRequestModalContext } from './ShopRequestModalContext';
import { MYSTERY_SHOP_MODAL_REQUEST_FROM, SHOP_REQUEST_TYPE_OPTIONS } from '../constants';
import ShopRequestStyledSelect from '../ShopRequestStyledSelect';

const Container = styled.div`
  display: flex;
  flex-flow: row;
  height: 36px;
  padding: 11px 30px;
  align-items: center;
  border-bottom: solid 1px var(--line-gray);
`;

const StyledLabel = styled(Typography.Text)`
  margin-right: 30px;
  font-family: var(--font-bold);
`;

const ShopRequestModalSourceSelector = () => {
  const { companies } = useAppSelector((state) => state.global);
  const { requestFrom, requestType, selectedCompany, setRequestType, setSelectedCompany } =
    useShopRequestModalContext();

  return (
    <Container>
      <StyledLabel>Request From</StyledLabel>
      {requestFrom === MYSTERY_SHOP_MODAL_REQUEST_FROM.COMPANY && (
        <ShopRequestStyledSelect
          width="290px"
          placeholder="Select company"
          options={companies?.map((c: CompanyType) => ({ value: c.id, label: c.name }))}
          onChange={(companyId) => setSelectedCompany(companyId)}
          value={selectedCompany}
          showSearch
          // search should be handled by backend to allow fuzzy searching
          filterOption={(input, option) =>
            Boolean(option?.label) &&
            typeof option?.label === 'string' &&
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      )}
      <StyledLabel>Request Type</StyledLabel>
      <ShopRequestStyledSelect
        width="290px"
        options={SHOP_REQUEST_TYPE_OPTIONS}
        onChange={setRequestType}
        value={requestType}
      />
    </Container>
  );
};

export default ShopRequestModalSourceSelector;
